import type {
    ProductVideoFragmentFragment,
    ResponsiveImageFragmentFragment,
} from 'generated/graphql';

const getThumbnailImage: (video: ProductVideoFragmentFragment) => {
    image: ResponsiveImageFragmentFragment;
    type: 'default' | 'custom';
} = (video) => {
    if (video?.LibraryImage?.LibraryImageFile) {
        return {
            image: video?.LibraryImage?.LibraryImageFile?.VideoCover,
            type: 'custom',
        };
    }

    const temp: ResponsiveImageFragmentFragment = {
        __typename: 'ResponsiveImage',
        ID: `ThumbnailOfficial_${video.ID}`,
        Mobile: video.ThumbnailOfficial,
        Desktop: video.ThumbnailOfficial,
    };

    return { image: temp, type: 'default' };
};

export { getThumbnailImage };
